import { forwardRef } from 'react';

// Lightweight replacements for framer-motion that use CSS animations instead
// This removes ~60KB from the bundle

interface MotionProps extends React.HTMLAttributes<HTMLElement> {
  initial?: any;
  animate?: any;
  exit?: any;
  whileHover?: any;
  whileTap?: any;
  whileInView?: any;
  viewport?: any;
  variants?: any;
  transition?: any;
}

const createMotionComponent = (tag: keyof JSX.IntrinsicElements) => {
  return forwardRef<HTMLElement, MotionProps>(({ initial, animate, exit, whileHover, whileTap, whileInView, viewport, variants, transition, className, ...props }, ref) => {
    const animationClasses = [className, initial && 'animate-fade-in'].filter(Boolean).join(' ');
    const Component = tag as any;
    return <Component ref={ref} className={animationClasses} {...props} />;
  });
};

export const motion = {
  div: createMotionComponent('div'),
  section: createMotionComponent('section'),
  button: createMotionComponent('button'),
  span: createMotionComponent('span'),
  p: createMotionComponent('p'),
  h1: createMotionComponent('h1'),
  h2: createMotionComponent('h2'),
  h3: createMotionComponent('h3'),
};

// AnimatePresence just renders children without animation
export const AnimatePresence = ({ children, mode }: { children: React.ReactNode; mode?: string }) => {
  return <>{children}</>;
};
